const ON_EVENT = {
    end: Symbol('end')
}

export class TaskStore {
    #execute = [];
    constructor(taskCount = 1) {
        this.taskCount = taskCount;
        this.taskList = [];
        this.loading = false;
        this.#execute=[];
        this[ON_EVENT.end]=[];
    }
    #run() {
        if (this.loading && this.taskList.length <= 0) {
            return;
        };
        this.#execute=[];
        this.loading = true;
        for (let i=0; i<this.taskCount; i++) {
            this.#createRunTask()
        };
        this.#executeAllTask();
    }
    add(task) {
        this.taskList.push(task);
        
        if (this.loading && this.#execute.length) {
            this.loading = true;
            const execute = this.#execute.shift();
            execute()
        }else {
            if (this.loading) {
                return
            }
           this.#run()
        }
    }
    #createRunTask() {
        const _this = this;
        this.#execute.push(async function taskFn (){
            const targetTask = _this.taskList.shift();
            if (!targetTask) {
                _this.#execute.push(taskFn);
                if (_this.#isRunAllTaskEnd()) {
                    _this.loading = false;
                    _this[ON_EVENT.end].forEach(fn=> {
                        fn&&fn()
                    })
                }
                return;
            }
            Promise.resolve(targetTask).then(task=>task()).then(taskFn).catch(taskFn)
        })
    }
    #executeAllTask() {
        for (let i=0; i<this.taskCount; i++) {
            const execute = this.#execute.pop();
            execute()
        };
    }
    #isRunAllTaskEnd() {
        return this.taskList.length <=0 && this.#execute.length === this.taskCount;
    }
    stopAllTask() {
        this.taskList = [];
        this.loading = false;
    }
    stopTask(task) {
        const index = this.taskList.indexOf(task);
        if (index > -1) {
            this.taskList.splice(index, 1)
        }
    }
    /**
     * 
     * @param { String } event 
     * @param { Function } fn 
     */
    on(event, fn) {
        const listKey = ON_EVENT[ event ];
        
        if (this[listKey]) {
            this[listKey].push(fn)
        }else {
            console.log(`无效的事件名: ${event}`);
        }
    }
};